import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { MapControlsContainer, LassoControl } from '../../../components/LeafletMap';
import { AreaMapContext } from '.';
const AreasMapControlsBar = () => {
    const { drawMode, handleDrawModeChange } = useContext(AreaMapContext);
    return (_jsx(MapControlsContainer, { children: _jsx(LassoControl, { drawMode: drawMode, changeDrawMode: handleDrawModeChange }) }));
};
AreasMapControlsBar.propTypes = {
    children: PropTypes.node,
};
export default AreasMapControlsBar;
